// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__31-FB","name":"Navbar_name__2urJr","title":"Navbar_title__2CGsW"};